import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import Process from "@/pages/Process";
import Portfolio, { CaseStudyDetail } from "@/pages/Portfolio";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Careers from "@/pages/Careers";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsOfService from "@/pages/TermsOfService";

// The cinematic home has its own header + footer; hide the global chrome
// only on that route. All other pages keep the existing Header/Footer.
function Chrome({ children }) {
  const location = useLocation();
  const isCinematic = location.pathname === "/";
  return (
    <>
      {!isCinematic && <Header />}
      {children}
      {!isCinematic && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ScrollToTop />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/:slug" element={<SolutionDetail />} />
            <Route path="/services" element={<Solutions />} /> {/* Redirect old URL */}
            <Route path="/process" element={<Process />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:id" element={<CaseStudyDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </Chrome>
        <CookieConsent />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
